const parseRawMessage = (rawMessage) => {
  try {
    if (!rawMessage || rawMessage === 'NA' || rawMessage === 'N/A') return {};
    const parsed = JSON.parse(rawMessage);
    return parsed.Type103 || parsed.Type104 || parsed;
  } catch (e) {
    return {};
  }
};


const getValueOrNA = (value) => {
  if (value === null || value === undefined || value === '' || value === 'NA') {
    return 'N/A';
  }
  return value;
};

const getVehicleInterfaceSpecAnother = (vehicleInterfaceSpec) => {
  switch (vehicleInterfaceSpec) {
    case "VEHICLE_INTERFACE_NONE":
      return "Wired";
    case "VEHICLE_INTERFACE_TOYOTA_LEGACY":
      return "CAN BUS + Wired";
    case "VEHICLE_INTERFACE_TOYOTA_H1T_1":
      return "CAN BUS ONLY";
    case "VEHICLE_INTERFACE_TOYOTA_RBC_1":
      return "Raymond Class I or II";
    case "VEHICLE_INTERFACE_TOYOTA_RB232_1":
      return "Raymond Class I or II";
    default:
      return "N/A";
  }
};

const getVehicleTypeValue = (vehicleType) => {
  const vehicleTypeMap = {
    "VEHICLE_TYPE_AERIAL_LADDER": "AERIAL LADDER",
    "VEHICLE_TYPE_AERIAL_WORK_PLATFORM": "AERIAL WORK PLATFORM",
    "VEHICLE_TYPE_AGV": "AGV",
    "VEHICLE_TYPE_AUTOMATED_LIFT_TRUCK": "AUTOMATED LIFT TRUCK",
    "VEHICLE_TYPE_BATTERY_CHANGER": "BATTERY CHANGER",
    "VEHICLE_TYPE_BATTERY_CHARGER": "BATTERY CHARGER",
    "VEHICLE_TYPE_BOOM_LIFT": "BOOM LIFT",
    "VEHICLE_TYPE_CAROUSEL": "CAROUSEL",
    "VEHICLE_TYPE_CHARGER": "CHARGER",
    "VEHICLE_TYPE_CONTAINER_HANDLER": "CONTAINER HANDLER",
    "VEHICLE_TYPE_CONVEYANCER": "CONVEYANCER",
    "VEHICLE_TYPE_DOCK_EQUIP": "DOCK EQUIP",
    "VEHICLE_TYPE_ELECTRIC_TOW_TRACTOR": "ELECTRIC TOW TRACTOR",
    "VEHICLE_TYPE_GENERATOR": "GENERATOR",
    "VEHICLE_TYPE_LARGE_CAPACITY": "LARGE CAPACITY",
    "VEHICLE_TYPE_ORDERPICKER": "ORDERPICKER",
    "VEHICLE_TYPE_PALLET_TRUCK": "PALLET TRUCK",
    "VEHICLE_TYPE_PERSONNEL_CARRIER": "PERSONNEL CARRIER",
    "VEHICLE_TYPE_REACH_TRUCK": "REACH TRUCK",
    "VEHICLE_TYPE_SCISSOR_LIFT": "SCISSOR LIFT",
    "VEHICLE_TYPE_SCRUBBER": "SCRUBBER",
    "VEHICLE_TYPE_SHRINK_WRAP_MACHINE": "SHRINK WRAP MACHINE",
    "VEHICLE_TYPE_SIDELOADER": "SIDELOADER",
    "VEHICLE_TYPE_SITDOWN_COUNTERBALANCE_EL": "SITDOWN COUNTERBALANCE (ELECTRIC)",
    "VEHICLE_TYPE_SITDOWN_COUNTERBALANCE_IC": "SITDOWN COUNTERBALANCE (IC)",
    "VEHICLE_TYPE_SKID_STEER_LOADER": "SKID STEER LOADER",
    "VEHICLE_TYPE_SPOTTER": "SPOTTER",
    "VEHICLE_TYPE_STACKER": "STACKER",
    "VEHICLE_TYPE_STANDUP_COUNTERBALANCE": "STANDUP COUNTERBALANCE",
    "VEHICLE_TYPE_SWEEPER": "SWEEPER",
    "VEHICLE_TYPE_SWEEPER_SCRUBBER": "SWEEPER SCRUBBER",
    "VEHICLE_TYPE_SWING_REACH": "SWING-REACH",
    "VEHICLE_TYPE_TELEHANDLER": "TELEHANDLER",
    "VEHICLE_TYPE_TOW_TRACTOR_IC": "TOW TRACTOR (IC)",
    "VEHICLE_TYPE_TRACTOR_TRAILER": "TRACTOR TRAILER",
    "VEHICLE_TYPE_TRANSTACKER": "TRANSTACKER",
    "VEHICLE_TYPE_TUGGER": "TUGGER",
    "VEHICLE_TYPE_WALKIE": "WALKIE",
    "VEHICLE_TYPE_WALKIE_STACKER": "WALKIE STACKER",
    "VEHICLE_TYPE_WALKIE_STRADDLE": "WALKIE STRADDLE",
    "VEHICLE_TYPE_WHEEL_LOADER": "WHEEL LOADER",
    "VEHICLE_TYPE_WORK_PLATFORM": "WORK PLATFORM"
  };

  return vehicleTypeMap[vehicleType] || "N/A";
};


const getUserNameFromEmail = (email) => {
  if (!email || email === 'N/A') return 'N/A';
  
  try {
    const namePart = email.split('@')[0];
    const words = namePart.split(/[_.]/).map(word => {
      if (!word) return '';
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return words.join(' ');
  } catch (e) {
    return 'N/A';
  }
};


const parseDateString = (dateStr) => {
  const [month, day, year] = dateStr.split('-');
  return new Date(year, parseInt(month) - 1, day);
};


const parseTimeString = (timeStr) => {
  const [hours, minutes, seconds] = timeStr.split(':').map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};


const findLatestEntry = (dateNode, serialNumber) => {
  let latestEntry = null;
  let latestTime = null;
  let latestDate = null;
  let latestType = null;

  
  for (const userId in dateNode) {
    const userNode = dateNode[userId];

  
    if (userNode['Install Summary']) {
      for (const time in userNode['Install Summary']) {
        const entry = userNode['Install Summary'][time];
        if (entry['Device Serial Number'] === serialNumber) {
          const timeValue = parseTimeString(time);
          if (!latestTime || timeValue > latestTime) {
            latestEntry = entry;
            latestTime = timeValue;
            latestType = 'Install Summary';
          }
        }
      }
    }

  
    if (userNode['Vehicle Pairing']) {
      for (const time in userNode['Vehicle Pairing']) {
        const entry = userNode['Vehicle Pairing'][time];
        if (entry['Device Serial Number'] === serialNumber) {
          const timeValue = parseTimeString(time);
          if (!latestTime || timeValue > latestTime) {
            latestEntry = entry;
            latestTime = timeValue;
            latestType = 'Vehicle Pairing';
          }
        }
      }
    }
  }

  return { entry: latestEntry, type: latestType, time: latestTime };
};


const findLatestDateTimeForFunction = (serialData, serialNumber, functionType) => {
  let latestDate = null;
  let latestTime = null;
  let latestDateTime = null;

  for (const date in serialData) {
    const dateNode = serialData[date];
    const dateObj = parseDateString(date);

    for (const userId in dateNode) {
      const userNode = dateNode[userId];

      if (userNode[functionType]) {
        for (const time in userNode[functionType]) {
          const entry = userNode[functionType][time];
          if (entry['Device Serial Number'] === serialNumber) {
            const timeValue = parseTimeString(time);

            if (!latestDate || dateObj > latestDate || 
                (dateObj.getTime() === latestDate.getTime() && timeValue > latestTime)) {
              latestDate = dateObj;
              latestTime = timeValue;
              latestDateTime = `${date} ${time}`;
            }
          }
        }
      }
    }
  }

  return latestDateTime || 'N/A';
};

const findLatestInstallSummaryEntry = (serialData, serialNumber) => {
  let latestEntry = null;
  let latestDate = null;
  let latestTime = null;

  for (const date in serialData) {
    const dateNode = serialData[date];
    const dateObj = parseDateString(date);

    for (const userId in dateNode) {
      const userNode = dateNode[userId];

      if (userNode['Install Summary']) {
        for (const time in userNode['Install Summary']) {
          const entry = userNode['Install Summary'][time];
          if (entry['Device Serial Number'] === serialNumber) {
            const timeValue = parseTimeString(time);

            if (!latestDate || dateObj > latestDate || 
                (dateObj.getTime() === latestDate.getTime() && timeValue > latestTime)) {
              latestEntry = entry;
              latestDate = dateObj;
              latestTime = timeValue;
            }
          }
        }
      }
    }
  }

  return latestEntry;
};

const extractSerialNumberData = (serialData, serialNumber) => {
  let overallLatestEntry = null;
  let overallLatestDate = null;
  let overallLatestTime = null;

  for (const date in serialData) {
    const dateNode = serialData[date];
    const dateObj = parseDateString(date);
    const { entry, time } = findLatestEntry(dateNode, serialNumber);

    if (entry) {
      if (!overallLatestDate || dateObj > overallLatestDate || 
          (dateObj.getTime() === overallLatestDate.getTime() && time > overallLatestTime)) {
        overallLatestEntry = entry;
        overallLatestDate = dateObj;
        overallLatestTime = time;
      }
    }
  }
  
  const latestInstallSummary = findLatestInstallSummaryEntry(serialData, serialNumber);

  if (!overallLatestEntry) {
    return {
      vin: 'N/A',
      deviceSerialNumber: serialNumber,
      firmwareVersion: 'N/A',
      recommendedVehicleInterfaceSpec: 'N/A',
      currentVehicleInterfaceSpec: 'N/A',
      siteId: 'N/A',
      vehiclePairingDateTime: 'N/A',
      installConfigDateTime: 'N/A',
      keySensor: 'N/A',
      liftSensor: 'N/A',
      operatorPresenceSensor: 'N/A',
      travelSensor: 'N/A',
      manufYear: 'N/A',
      vehicleType: 'N/A',
      vehicleModel: 'N/A',
      vehicleSerial: 'N/A',
      mobileAppVersion: 'N/A',
      mobileBrand: 'N/A',
      mobileModel: 'N/A',
      os: 'N/A',
      userLanguagePref: 'N/A',
      userId: 'N/A',
      userName: 'N/A',
      userRole: 'N/A'
    };
  }

  const rawMessageData = parseRawMessage(overallLatestEntry['Raw Message']);

  const mobileDeviceInfo = overallLatestEntry['Mobile Device Info'] || {};

  const vehicleInterfaceSpecRaw = rawMessageData.vehicleInterfaceSpec || rawMessageData.interface;
  const currentVehicleInterfaceSpec = getVehicleInterfaceSpecAnother(vehicleInterfaceSpecRaw);
  
  const recommendedVehicleInterfaceSpecRaw = overallLatestEntry['Recommended Vehicle Interface Spec'];
  const recommendedVehicleInterfaceSpec = getVehicleInterfaceSpecAnother(recommendedVehicleInterfaceSpecRaw);
  
  const siteId = getValueOrNA(overallLatestEntry['Site ID']) !== 'N/A' 
    ? getValueOrNA(overallLatestEntry['Site ID']) 
    : getValueOrNA(rawMessageData.siteID || rawMessageData.siteId);
  

  const keySensor = latestInstallSummary ? getValueOrNA(latestInstallSummary['Key']) : 'N/A';
  const liftSensor = latestInstallSummary ? getValueOrNA(latestInstallSummary['Lift']) : 'N/A';
  const operatorPresenceSensor = latestInstallSummary ? getValueOrNA(latestInstallSummary['Operator Presence']) : 'N/A';
  const travelSensor = latestInstallSummary ? getValueOrNA(latestInstallSummary['Travel']) : 'N/A';
  

  const manufYear = getValueOrNA(overallLatestEntry['Manufacture Year']);
  
  const userNameFromEntry = overallLatestEntry['User Name'];
  const userName = userNameFromEntry && userNameFromEntry !== 'null' && userNameFromEntry !== '' 
    ? userNameFromEntry.replace(/\t/g, ' ') 
    : getUserNameFromEmail(overallLatestEntry['User ID']);

  return {
    vin: getValueOrNA(overallLatestEntry['Vin']),
    deviceSerialNumber: serialNumber, 
    firmwareVersion: getValueOrNA(overallLatestEntry['DHU Firmware Version']),
    recommendedVehicleInterfaceSpec: recommendedVehicleInterfaceSpec,
    currentVehicleInterfaceSpec: currentVehicleInterfaceSpec,
    siteId: siteId,
    vehiclePairingDateTime: findLatestDateTimeForFunction(serialData, serialNumber, 'Vehicle Pairing'),
    installConfigDateTime: findLatestDateTimeForFunction(serialData, serialNumber, 'Install Summary'),
    keySensor: keySensor,
    liftSensor: liftSensor,
    operatorPresenceSensor: operatorPresenceSensor,
    travelSensor: travelSensor,
    manufYear: manufYear,
    vehicleType: getVehicleTypeValue(rawMessageData.vehicleType),
    vehicleModel: getValueOrNA(rawMessageData.vehicleModel),
    vehicleSerial: serialNumber, 
    mobileAppVersion: getValueOrNA(mobileDeviceInfo['Mobile App Version'] || mobileDeviceInfo['Mobile_App_Version']),
    mobileBrand: getValueOrNA(mobileDeviceInfo['Mobile Brand'] || mobileDeviceInfo['Mobile_Brand']),
    mobileModel: getValueOrNA(mobileDeviceInfo['Model']),
    os: getValueOrNA(mobileDeviceInfo['OS Version'] || mobileDeviceInfo['OS_Version']),
    userLanguagePref: getValueOrNA(mobileDeviceInfo['User Language Preference'] || mobileDeviceInfo['User_Language_Preference']),
    userId: getValueOrNA(overallLatestEntry['User ID']),
    userName: userName,
    userRole: getValueOrNA(overallLatestEntry['User Role'])
  };
};


export const extractDeviceConfigurations = (firebaseData, envName = null) => {
  const configurations = [];

  const ignoredSerialNumbers = ['77777', '-234', '-N', '04aug-testing', '10-17-2024', '10-23-2025', 'N/A'];

  for (const serialNumber in firebaseData) {
    const serialData = firebaseData[serialNumber];
    
    if (typeof serialData !== 'object' || serialData === null) continue;

    if (ignoredSerialNumbers.includes(serialNumber)) continue;

    const config = extractSerialNumberData(serialData, serialNumber);
    configurations.push({
      id: configurations.length + 1,
      ...config
    });
  }

  return configurations;
};

export const extractDeviceConfigurationsByEnv = (firebaseData, envName) => {
  return extractDeviceConfigurations(firebaseData, envName);
};

export default {
  extractDeviceConfigurations,
  extractDeviceConfigurationsByEnv
};
